import React from "react";
import '../css/project.css';

function Project(props){
    return (
        <div className="project-square">
            <img src={require(`../img/projects/${props.projectImage}.png`)} alt="" />
                <div className="project-information">
                    <p className="project-name">{props.projectName}</p>
                    <div className="technologies-used">
                        {props.languages.map((technology, index) => (
                            <div className="technology-used" key={index}>
                                <img src={require(`../img/${technology.image}.png`)} alt={technology.name} />
                                <p className="technology-name">{technology.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <a href={ props.url } target="_blank" rel="noopener noreferrer"><button className="view-project">View project</button></a>
        </div>
    );
}

export default Project;